<div class="card">
    <div class="card" style="display: flex; justify-content: space-between; align-items: center; padding: 0; border: none; background-color: transparent;">
        <div>
            <h4><strong style=" margin-left: 10px;">Payment List</strong></h4>
        </div>
        <div style="display: flex; margin-top: -10px;">
            <button pButton type="button" icon="pi pi-download" (click)="downloadExcel()" style=" background-color: #2c436b;" label="Excel Report"></button>
            <!-- <button pButton type="button" icon="pi pi-download" (click)="downloadPDF()" style="height: 10px; margin-right: 10px; background-color: #2c436b;" label="PDF Report"></button> -->
        </div>
    </div>
    <hr>
    <p-table [columns]="cols"  #tt [value]="getPaymentList" class="table-bordered" >
        <ng-template pTemplate="header" let-columns>
            <tr >
                <th *ngFor="let col of columns">
                    {{ col.header }}
                </th>
            </tr>
            <tr>
              <th *ngFor="let col of cols">
                <ng-container *ngIf="col.field === 'posting_date' || col.field === 'document_date'; else textInput">
                  <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                </ng-container>
                <ng-template #textInput>
                  <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                </ng-template>
                  <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" /> -->
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              <td *ngFor="let col of columns">
                <!-- Check if the field is 'posting_date' and format it accordingly -->
                <span *ngIf="col.field === 'posting_date' || col.field === 'document_date'; else defaultField">
                  {{ rowData[col.field] | date: 'dd.MM.yyyy' }}
                </span>
                <ng-template #defaultField>
                    {{ rowData[col.field] }}
                </ng-template>
            </td>
            </tr>
        </ng-template>
    </p-table>
    <div>
        <p-paginator
            [rows]="limit"
            [first]="(currentPage - 1) * limit"
            [totalRecords]="totalRecords"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 20,30,50,100]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
       />
    </div>
</div>
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
